import React, { useState } from 'react';
import './style.scss';
import { LabelValueSelector, LabelValueSelectorProps, Selector, SelectorProps } from '../selector';
import { FormError } from 'views/mutual/formErrorScroll';

export enum UnitSelectorPosition {
  before = 'unitBefore',
  after = 'unitAfter',
}
export type UnitSelectorProps = {
  unit: UnitSelectorPosition;
  label: string;
} & SelectorProps;

export const UnitSelector = (props: UnitSelectorProps) => {
  const { unit, label } = props;
  return (
    <>
      <div className="unitSelector">
        {label && <div className={`unitSelector_unit ${unit}`}>{label}</div>}
        <Selector {...props} />
      </div>
    </>
  );
};

export const UnitSelector2 = (props: {
  selectedOption: string;
  setSelectedOption: (value: string) => void;
  error?: string;
}) => {
  const [datas, setDatas] = useState(
    props.selectedOption === '' || !props.selectedOption
      ? Array(4).fill('0')
      : // 10桁にしてから必要な部分(頭4桁: 0～3)を抜き取ってセット
        props.selectedOption.replaceAll(',', '').padStart(10, '0').substring(0, 4).split(''),
  );
  return (
    <>
      <div className="unitSelector unitSelector2">
        <div className={`unitSelector_unit ${UnitSelectorPosition.after}`}>百万円</div>
        {datas.map((value, index) => {
          return (
            <Selector
              key={index}
              disabled={index === datas.length - 1}
              selectedOption={value}
              setSelectedOption={(option) => {
                const newDatas = datas.map((x, i) => (index === i ? option : x));
                setDatas(newDatas);
                props.setSelectedOption([...newDatas].join('') + '000000');
              }}
              options={Array.from({ length: 10 }, (_, i) => i.toString())}
            />
          );
        })}
      </div>
      <FormError className="selector_error" error={props.error} />
    </>
  );
};

export type LabelValueUnitSelectorProps = {
  unit: UnitSelectorPosition;
  label: string;
} & LabelValueSelectorProps;
export const LabelValueUnitSelector = (props: LabelValueUnitSelectorProps) => {
  const { unit, label } = props;
  return (
    <>
      <div className="unitSelector">
        {label && <div className={`unitSelector_unit ${unit}`}>{label}</div>}
        <LabelValueSelector {...props} />
      </div>
    </>
  );
};
